import { push, replace } from 'connected-react-router';
import queryString from 'query-string';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { Types } from '.';
import { Action } from '../store';

export const customMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: Action): any => {
  switch (action.type) {
    // For any intercepted actions, ensure they get dispatched from the store rather
    // than using next so that they go through the built-in middleware.
    case Types.REPLACE_QUERY: {
      const state = store.getState();
      const fn = action.payload.replacePath ? replace : push;
      store.dispatch(
        fn({
          pathname: (state as any).router.location.pathname,
          search: queryString.stringify(action.payload.query),
        }),
      );
      return;
    }

    case Types.UPDATE_QUERY: {
      const state = store.getState();
      const fn = action.payload.replacePath ? replace : push;
      const query = { ...queryString.parse((state as any).router.location.search), ...action.payload.query };
      store.dispatch(
        fn({
          pathname: (state as any).router.location.pathname,
          search: queryString.stringify(query),
        }),
      );
      return;
    }

    default:
      return next(action);
  }
};
